"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAppointmentBeenMissed = exports.wasNotInitializedWithAppointmentData = exports.shouldSkipProvider = exports.isCancelationExpired = exports.isCancelationDisabled = exports.isAppointmentCanceled = exports.hasAppointment = void 0;
exports.hasAppointment = '@guard/HAS_APPOINTMENT';
exports.isAppointmentCanceled = '@guard/IS_APPOINTMENT_CANCELED';
exports.isCancelationDisabled = '@guard/IS_CANCELATION_DISABLED';
exports.isCancelationExpired = '@guard/IS_CANCELATION_EXPIRED';
exports.shouldSkipProvider = '@guard/SHOULD_SKIP_PROVIDER';
exports.wasNotInitializedWithAppointmentData = '@guard/WAS_NOT_INITIALIZED_WITH_APPOINTMENT_DATA';
exports.hasAppointmentBeenMissed = '@guard/HAS_APPOINTMENT_BEEN_MISSED';
//# sourceMappingURL=Guards.js.map